import Banner from '../common/Banner';

export interface IdentityProvider {
  contexts: Record<string, string>;
  nameid: string;
}

export interface SSOUserResetPasswordBannerProps {
  identityProviders: Record<string, IdentityProvider>;
  athenaHost: string;
}

export default function SSOUserResetPasswordBanner({
  identityProviders,
  athenaHost,
}: SSOUserResetPasswordBannerProps) {
  const ssoLinks: Array<{ idpId: string; nameid: string; url: string }> = [];

  Object.entries(identityProviders).forEach(([ idpId, provider ]) => {
    const nameid = provider.nameid || idpId;
    const url = `https://${athenaHost}/1/1/login/startoidc.esp?IDP=${idpId}`;
    ssoLinks.push({ idpId, nameid, url });
  });

  return (
    <Banner alertType="attention">
      <div>
        <p>
          You cannot reset your password because your account is configured for single sign-on
          (SSO). Please use your organization&apos;s SSO login link(s) below:
        </p>
        <div className="fe_u_margin--top-small fe_u_margin--bottom-small">
          {ssoLinks.map((link, index) => (
            <div key={`${link.idpId}-${index}`} className="fe_u_margin--top-small">
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Login for {link.nameid}
              </a>
            </div>
          ))}
        </div>
        <p>
          If you need help with your account&apos;s SSO settings, please contact your
          administrator.
        </p>
      </div>
    </Banner>
  );
}
